export const PROTOCOL =
  process.env.REACT_APP_ENV === "staging" ? "https://" : "https://";
export const DOMAIN =
  process.env.REACT_APP_ENV === "staging"
    ? process.env.REACT_APP_APOLLO_URI.replace("https://", "")
    : "manage.kekrebrokerapp.com";
export const COOKIE_NAME_AUTH_TOKEN = "kek_re_auth_token";
export const COOKIE_NAME_AUTH = "kek_re_auth";
export const PUSHER_KEY = "8fdc449c93173e31d8a2";
export const PUSHER_CLUSTER = "eu";
export const CHANNEL = "a2VrcmUtcHJpdmF0ZS1jaGFubmVs";
export const EVENT = "a2VrcmUtcHJpdmF0ZS1jaGFubmVs-event";
